import { HttpResponse } from "@angular/common/http";

export function readHeaderFilename(response: HttpResponse<Blob>, defaultfilename?: string): string {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition?.split('filename=')[1]?.replace(/['"]/g, '') || defaultfilename;

    return filename;
}

export function downloadBlob(response: HttpResponse<Blob>, defaultfilename?: string){
    const filename = readHeaderFilename(response, defaultfilename);
    const blob = response.body as Blob;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename; // Specify the file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

export function createUrlFromBlob(response: HttpResponse<Blob>): string {
    const blob = response.body as Blob;
    return window.URL.createObjectURL(blob);  // Create Object URL from Blob
  }